import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	pollsWrapper: {
		width     : "100%",
		overflowY : "auto",
		maxHeight : "calc(100vh - 100px)"
	},
	overlay: {
		backgroundColor : "rgba(0, 0, 0, 0.55)",
		inset           : "0",
		position        : "absolute",
		display         : "none",
		zIndex          : "5"
	},
	overlayShow: {
		backgroundColor : "rgba(0, 0, 0, 0.55)",
		inset           : "0",
		position        : "absolute",
		display         : "block",
		zIndex          : "5"
	},
	crossButton: {
		cursor : "pointer",
		height : "3rem",
		width  : "3rem"
	},
	header: {
		display              : "flex",
		height               : "10%",
		alignItems           : "center",
		padding              : "1.5rem",
		justifyContent       : "space-between",
		borderTopLeftRadius  : "1rem",
		borderTopRightRadius : "1rem",
		backgroundColor      : theme.other.colors.dialog.primary
	},
	headerText: {
		fontWeight : "500",
		fontSize   : "1.5rem"
	},
	tabs: {
		position                      : "sticky",
		height                        : "7%",
		top                           : "0",
		backgroundColor               : theme.other.colors.dialog.primary,
		borderBottom                  : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`,
		zIndex                        : "2",
		"& .MuiTab-root.Mui-selected" : {
			fontWeight           : "500",
			background           : `linear-gradient(to bottom, ${ theme.other.paletteNew.primaryDarkBlue },${ theme.other.paletteNew.primaryLightBlue })`,
			WebkitBackgroundClip : "text",
			WebkitTextFillColor  : "transparent"
		  }

	  },
	tab: {
		width         : "50%",
		fontSize      : "1.5rem",
		color         : `${ theme.other.paletteNew.secondaryDarkGrey }`,
		fontWeight    : "500 !important",
		textTransform : "none"

	},
	indicator: {
		background           : `linear-gradient(to bottom, ${ theme.other.paletteNew.primaryDarkBlue },${ theme.other.paletteNew.primaryLightBlue })`,
		height               : "3px",
		borderTopRightRadius : "10px",
		borderTopLeftRadius  : "10px"
	},
	tabContainer: {
		padding       : "2rem",
		display       : "flex",
		flexDirection : "column",
		gap           : "2rem",
		height        : "100%"
	},
	createPollsButton: {
		width          : "100%",
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center",
		color          : theme.other.paletteNew.primaryDarkBlue,
		border         : `2px solid ${ theme.other.paletteNew.primaryDarkBlue }`,
		padding        : "1rem",
		borderRadius   : "10px",
		cursor         : "pointer",
		opacity        : props?.disableCreatePoll ? 0.5 : 1
	},
	tabPanel: {
		height          : "70vh",
		overflow        : "scroll",
		backgroundColor : theme.other.colors.dialog.secondary,
		"& > div"       : {
			height: "100%"
		}
	},
	errorText: {
		fontWeight   : "500",
		color        : theme.other.colors.text.primary,
		marginBottom : "1rem"
	},
	errorSubHeading: {
		color: theme.other.colors.text.secondary
	},
	emptyFeedWrapper: {
		display        : "flex",
		flexDirection  : "column",
		alignItems     : "center",
		textAlign      : "center",
		justifyContent : "center",
		height         : "100%"
	},
	deleteText: {
		backgroundColor : theme.other.paletteNew.darkModeDarkGrey20,
		padding         : "1rem",
		borderRadius    : "10px"
	},

	tabsRoot: {
		width: props?.isMobile ? "100vw" : "25vw"
	},
	tabsList: {
		width        : "100%",
		display      : "flex",
		borderBottom : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`
	},
	tabsLabel: {
		color: "inherit"
	},
	tabsTab: {
		padding      : "1.5rem 0 1.5rem 0",
		borderRadius : "0 !important",
		marginBottom : "unset",
		background   : theme.other.colors.background.tertiary,
		borderBottom : "none",
		":hover"     : {
			background: theme.other.colors.background.tertiary
		},
		":active": {
			borderBottom: "0"
		},
		":focus": {
			borderBottom : "0",
			marginBottom : "0 !important"

		},
		color            : theme.other.colors.text.secondary,
		"&[data-active]" : {
			position   : "relative",
			fontWeight : "500",
			color      : `${ theme.other.paletteNew.primaryDarkBlue } !important`,
			border     : "0",
			":after"   : {
				content      : `'${ "" }'`,
				width        : "100%",
				height       : "3px",
				position     : "absolute",
				background   : "#126bd5",
				bottom       : "0",
				borderRadius : "10px 10px 0 0"
			}
		}
	},
	tabsPanel: {
		height : props?.isMobile ? "50vh" : "calc( 100vh - 115px )",
		width  : "100%"
	}

} ) );
